import { Component } from '@angular/core';
import { AppConfig } from '../app-config';
import { shouldUseAppConfigForEnvironment } from '../shared/helpers/environments';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'maintenance',
  templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent {
  redirectLocation: string;
  inMaintenanceMode: boolean = true;

  constructor(private appConfig: AppConfig, private router: Router, private titleService: Title) {
    if (shouldUseAppConfigForEnvironment(appConfig && appConfig.config && appConfig.config.environment)) {
      this.redirectLocation = appConfig.config.logoutRedirectUrl;
      this.inMaintenanceMode = appConfig.config.maintenance;
    } else {
      this.redirectLocation = environment.logoutRedirectUrl;
      this.inMaintenanceMode = environment.maintenance;
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Online System Maintenance');
    if(!this.inMaintenanceMode) {
      console.log("Not in maintenance mode- forwarding use to loans page");
      this.router.navigateByUrl('/loans-images');
    }
  }

  returnHome() {
    window.location.href = this.redirectLocation;
  }

}
